import { colors } from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { useOverflow } from "shared/hooks/useOverflow";
import { body3SemiBold } from "shared/styles/typography";

import { SingleRoleDescriptionProps } from "./types";

const SingleRoleDescription = ({ description }: SingleRoleDescriptionProps) => {
    const { gray700 } = colors;

    const { ref, isOverflowing } = useOverflow([description]);

    return description.trim().length > 0 ? (
        <div>
            <TooltipGeneral
                title={description}
                disableHoverListener={!isOverflowing}
                placement={TOOLTIP_PLACEMENT.Top}
                removeArrow
            >
                <div
                    ref={ref}
                    css={[
                        body3SemiBold,
                        {
                            color: gray700,
                            overflowX: "hidden",
                            textOverflow: "ellipsis"
                        }
                    ]}
                >
                    {description}
                </div>
            </TooltipGeneral>
        </div>
    ) : null;
};

export default SingleRoleDescription;
